import React from 'react';
import './departement.css';
import { Footer, Header } from '../index';
import { Link } from 'react-router-dom';
import directeurT from'../../asserts/images/directeurT.jpg';

function DepartementT(props) {
  return (
    <div style={{ backgroundColor: '#FCFCFC' }}>
      <Header />
      <div className='containerTECH'>
        <div className='bgTECH'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-160px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'45px'}}className="container-fluid text-white text-center" id='h1t'>Département De Technologie</h1>
          <p ><Link className='linkdep' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkdep'
            to="/"> Département </Link>  <span>{'>'}</span> <Link className='linkdep'
            to="/">Technologie</Link> </p></div>
      </div>
      <div className="DEP" style={{ backgroundColor: '#FCFCFC' }}>
        <div className='boxdep1'>
        <h1 className="container-fluid text-center" style={{color:'#162533' }}>Directeur De Département</h1>
        <div className='pres'>
            <div className='IMAGE'>    
                 <img src={directeurT} alt="intro" />               
            </div>
            <div className='coordonne'><p><span>Nom : </span>Sadok BAZINE <br/> <span>Email : </span><a href=''>sadok.bazine@gmail.com</a> </p> </div>

        </div>
        </div>
        <div className='boxdep2'>
        <h1 className="container-fluid text-center " style={{color:'#162533' }}>Présentation</h1>
        <p className='parag'>
          <br/>
        Le département de Technologie appliquée à l'Institut Supérieur d'Informatique et de Mathématiques 
         (ISIMM) est un bastion de l'enseignement et de la recherche dans le domaine 
        de l'électronique. Doté d'une équipe professorale compétente et passionnée, le département s'engage à 
        fournir une formation de pointe aux étudiants intéressés par les technologies électroniques.
         Les programmes d'études sont soigneusement conçus pour combiner la théorie et la pratique, 
         permettant aux étudiants d'acquérir une compréhension approfondie des principes fondamentaux
         de l'électronique tout en développant des compétences pratiques essentielles. Des laboratoires
         bien équipés offrent aux étudiants l'occasion de mettre en pratique leurs connaissances et de 
        travailler sur des projets innovants. 
        </p>
        
        </div>

        
      </div>
      <Footer />
    </div>
  )
}

export default DepartementT;
 /*<a target="_blank" href="/images/organigramme.jpg">
    </a>*/